import { connectStats } from 'react-instantsearch-dom';

const Stats = ({ nbHits }) => {
  if (nbHits > 50)
    return <p className="search-status">Results limited to top 50</p>;
  if (nbHits > 0) return <p className="search-status">{`${nbHits} results`}</p>;
};

const CustomStats = connectStats(Stats);

export default CustomStats;
